import React, { Component } from 'react';
import { ButtonGroup, Button } from 'react-bootstrap/lib';
import { LinkContainer } from 'react-router-bootstrap';

class LedenMenu extends Component {

    render() {
        let item = this.props.id
        return (
            <div className="LedenMenu">
                <ButtonGroup justified>
                    <LinkContainer exact to={"/admin/leden/lid/gegevens/" + item}><Button href="#">Gegevens</Button></LinkContainer>
                    <LinkContainer exact to={"/admin/leden/lid/bedrijf/" + item}><Button href="#">Bedrijf</Button></LinkContainer>
                    <LinkContainer exact to={"/admin/leden/lid/kennis/" + item}><Button href="#">Kennis</Button></LinkContainer>
                    <LinkContainer exact to={"/admin/leden/lid/werkervaring/" + item}><Button href="#">Werkervaring</Button></LinkContainer>
                    <LinkContainer exact to={"/admin/leden/lid/permanente-kennis/" + item}><Button href="#">Permanente kennis</Button></LinkContainer>
                </ButtonGroup>

                <ButtonGroup justified>
                    <LinkContainer exact to={"/admin/leden/lid/doorlopende-werkervaring/" + item}><Button href="#">Doorlopende werkervaring</Button></LinkContainer>
                    <LinkContainer exact to={"/admin/leden/lid/beoordelingsdocumenten/" + item}><Button href="#">Beoordelingsdocumenten</Button></LinkContainer>
                    <LinkContainer exact to={"/admin/leden/lid/verklaringen/" + item}><Button href="#">Verklaringen</Button></LinkContainer>
                    <LinkContainer exact to={"/admin/leden/lid/kennis-omzetten/" + item}><Button href="#">Kennis omzetten</Button></LinkContainer>
                    {/* <LinkContainer exact to={"/admin/leden/lid/inloggen/" + item}><Button href="#">Inloggen</Button></LinkContainer> */}
                </ButtonGroup>
            </div>
            // <Navbar fluid bsStyle="default" className="LedenMenu">
            //     <Navbar.Header className="">
            //         <Navbar.Brand className="visible-xs">
            //             Leden menu
            //         </Navbar.Brand>
            //         <Navbar.Toggle />
            //     </Navbar.Header>
            //     <Navbar.Collapse>
            //         <Nav>
            //             <LinkContainer exact to="/admin/leden/lid/gegevens">
            //                 <NavItem eventKey={2}>
            //                     Gegevens
            //                 </NavItem>
            //             </LinkContainer>
            //             <LinkContainer exact to="/admin/leden/lid/bedrijf">
            //                 <NavItem eventKey={2}>
            //                     Bedrijf
            //                 </NavItem>
            //             </LinkContainer>
            //             <LinkContainer exact to="/admin/leden/lid/kennis">
            //                 <NavItem eventKey={3}>
            //                     Kennis
            //                 </NavItem>
            //             </LinkContainer>
            //             <LinkContainer exact to="/admin/leden/lid/werkervaring">
            //                 <NavItem eventKey={6}>
            //                     Werkervaring
            //                 </NavItem>
            //             </LinkContainer>
            //             <LinkContainer exact to="/admin/leden/lid/permanente-kennis">
            //                 <NavItem eventKey={8}>
            //                     Permanente kennis
            //                 </NavItem>
            //             </LinkContainer>
            //             <LinkContainer exact to="/admin/leden/lid/doorlopende-werkervaring">
            //                 <NavItem eventKey={10}>
            //                     Doorlopende werkervaring
            //                 </NavItem>
            //             </LinkContainer>
            //             <LinkContainer exact to="/admin/leden/lid/beoordelings-documenten">
            //                 <NavItem eventKey={11}>
            //                     Beoordelingsdocumenten
            //                 </NavItem>
            //             </LinkContainer>
            //             <LinkContainer exact to="/admin/leden/lid/verklaringen">
            //                 <NavItem eventKey={11}>
            //                     Verklaringen
            //                 </NavItem>
            //             </LinkContainer>
            //             <LinkContainer exact to="/admin/leden/lid/kennis-omzetten">
            //                 <NavItem eventKey={11}>
            //                     Kennis omzetten
            //                 </NavItem>
            //             </LinkContainer>
            //             <LinkContainer exact to="/admin/leden/lid/inloggen">
            //                 <NavItem eventKey={11}>
            //                     Inloggen
            //                 </NavItem>
            //             </LinkContainer>
            //         </Nav>
            //     </Navbar.Collapse>
            // </Navbar>
        );
    }
}

export default LedenMenu;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/LedenMenu.js